import { apiClient } from '@/shared/api/client'

export async function getVendors() {
  const response = await apiClient.get('/purchase/vendors')
  return response.data
}

export async function createVendor(payload) {
  const response = await apiClient.post('/purchase/vendors', payload)
  return response.data
}

export async function updateVendor(vendorId, payload) {
  const response = await apiClient.put(`/purchase/vendors/${vendorId}`, payload)
  return response.data
}

export async function deleteVendor(vendorId) {
  const response = await apiClient.delete(`/purchase/vendors/${vendorId}`)
  return response.data
}
